import Service from "../Service";
const resource = "HmnHoursWorked/";

export default {
  pagination(dtr, requestID) {
    return Service.post(resource + "pagination", dtr, {
      params: { requestID: requestID },
    });
  },
  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID: requestID },
    });
  },
  excel(obj, requestID) {
    return Service.post(resource + "excel", obj, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  listDaily(parameters, requestID) {
    return Service.post(resource + "listDaily", parameters, {
      params: { requestID: requestID },
    });
  },
  excelDaily(obj, requestID) {
    return Service.post(resource + "excelDaily", obj, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  listMarkingWorker(parameters, requestID) {
    return Service.post(resource + "listMarkingWorker", parameters, {
      params: { requestID: requestID },
    });
  },
  excelMarkingWorker(obj, requestID) {
    return Service.post(resource + "excelMarkingWorker", obj, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  updateCache(WkrID, dateIni, dateEnd, requestID) {
    return Service.post(
      resource + "updateCache",
      {},
      {
        params: {
          WkrID: WkrID,
          StarTime: dateIni,
          EndDate: dateEnd,
          requestID: requestID,
        },
      }
    );
  },
  async DistributionCache(filter, Compense, userID) {
    filter.Compensation = Compense;

    return Service.post(
      resource + "DistributionCache",//"getWeeklySchedule",
      filter,
      {
        params: {
          requestID: userID,
        },
      }
    );
  },
  async exportToExcel(filter, requestID) {
    return Service.post(resource + "exportToExcel", filter, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  async HoursWorked_ReportExcel(filter, requestID) {
    return Service.post(resource + "HoursWorkedExcel", filter, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  // --- RECONSIDERACIONES ---
  async createReconsideration(payload, requestID) {
    return Service.post(resource + "createReconsideration", payload, {
      params: { requestID: requestID }
    });
  },
  async revertReconsideration(reconsiderationID, requestID) {
    return Service.post(resource + "revertReconsideration", { reconsiderationID: reconsiderationID }, {
      params: { requestID: requestID }
    });
  },
  async getReconsiderationHistory(CacheDetailID, requestID) {
    return Service.post(resource + "reconsiderationHistory", {
      CacheDetailID: CacheDetailID
    }, {
      params: { requestID: requestID }
    });
  },
  async validateRows(filter, requestID) {
    return Service.post(resource + "validateConsolidated", filter, {
      params: { requestID: requestID },
    });
  },
  async syncDay(wkr, date, requestID) {
    return Service.post(resource + "syncDay", {
      WkrID: wkr,
      InitDate: date
    }, {
      params: { requestID: requestID },
    });
  },
  consolidateReportP(dtr, requestID) {
    return Service.post(resource + "consolidateReportP", dtr, {
      params: { requestID: requestID },
    });
  },
    async showDistribution(filter, userID) {
      filter.Compensation = 0;
    return Service.post(
      resource + "showDistribution",
      filter,
      {
        params: {
          requestID: userID,
        },
      }
    );
  },
  async showHourBankPreview(filter, userID) {
    return Service.post(
      resource + "showHourBankPreview",
      filter,
      {
        params: {
          requestID: userID,
        },
      }
    );
  },
  async updateStatusPayd(item, userID) {
    return Service.post(
      resource + "updateStatusPayd",
      item,
      {
        params: {
          requestID: userID,
        },
      }
    );
  },
  async changeStatusRest(item, userID) {
    return Service.post(
      resource + "changeStatusRest",
      item,
      {
        params: {
          requestID: userID,
        },
      }
    );
  }
  
};
